declare global {
  interface String {
    fullTrim(): string;

    equalsWith(stringToCompare: string): boolean;

    toBoolean(): boolean;
  }
}

String.prototype.fullTrim = function (): string {
  return this.trim().replace(/[\s]+/g, ' ');
};

String.prototype.equalsWith = function (stringToCompare: string): boolean {
  return (
    typeof stringToCompare === typeof this &&
    this.toLowerCase().fullTrim() === stringToCompare.toLowerCase().fullTrim()
  );
};

String.prototype.toBoolean = function (): boolean {
  return this === 'true';
};

export {};
